import React from 'react'

class SEO extends React.Component{

	render() {
		return (
			<>
			</>
		)
	}
}

export default SEO